import React from "react";
import { Button, Dropdown, Menu, message } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { useSaleSoModel } from "../saleSoModel";
import { useSaleSoDetailModel } from "./details/saleSoDetailModel";
import useNavModel from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { AuthButton } from "@/components/auth/AuthButton";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { ResourcesAuthBtn } from "@/types/ResourcesAuthEnum";
import { mianCode } from "@/utils/constants";
import { DownOutlined } from "@ant-design/icons";
import { formatNum } from "@/utils/utils";

export const DataBox = () => {
    const { selectedRowKeys, selectedRow, descTotal,rowsDescTotal, invalidateData, setPrint, detailsExport, loadData, listExport } = useSaleSoModel();
    const { Settle, WhConfirm } = useSaleSoDetailModel();
    const { selectedNavId, addNav, findNav, selectNav, switchNavState, replaceNav } = useNavModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            // globalPrompt("message", { text: "请选择单条数据进行编辑", type: "warning" });
            globalPrompt("message", { text: Locale["Please select a single piece of data for editing."], type: "warning" });

            return;
        }
        if (selectedRow.status === "sale.change") {
            // globalPrompt("message", { text: "该单据已作废，无法进行编辑", type: "warning" });
            globalPrompt("message", { text: Locale["The document has been cancelled and cannot be edited."], type: "warning" });

            return;
        }
        if (selectedRow.status === "sale.settle") {
            // globalPrompt("message", { text: "该单据已结算，无法进行编辑", type: "warning" });
            globalPrompt("message", { text: Locale["The document has been settled and cannot be edited."], type: "warning" });

            return;
        }
        if (selectedRow.status === "sale.stock-io") {
            globalPrompt("message", { text: Locale["The document has been stocked out and cannot be edited."], type: "warning" });
            // globalPrompt("message", { text: "该单据已出库，无法进行编辑", type: "warning" });
            return;
        }
        let saleSoEditKey = "2-3-2";
        let isFindNav = findNav(saleSoEditKey);
        if (!isFindNav) {
            addNav(saleSoEditKey, { id: selectedRow.saleCode as string, mode: "edit" });
        } else {
            globalPrompt("modal", {
                // title: "销售单跳转详情",
                title: Locale["Jump to the detail page of Sales doc."],
                type: "warning",
                // text: "您还有销售单详情未保存，是否跳转",
                text: Locale["The detail page of Sales doc has not been saved. Do you still want to jump?"],
                okText: "跳转未保存页",
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                cancelText: "打开新页签",
                onCancel: () => {
                    switchNavState(saleSoEditKey, { id: selectedRow.saleCode as string, mode: "edit" });
                    // updateEditFormVal(null);
                }
            })
        }
    }
    const onLook = () => {
        if (selectedRowKeys.length !== 1) {
            // globalPrompt("message", { text: "请选择单条数据进行查看", type: "warning" });
            globalPrompt("message", { text: Locale["Please select a single piece of data to view."], type: "warning" });
            return;
        }
        let supplierEditKey = "2-3-3";
        replaceNav(
            selectedNavId,
            "2-3-3",
            { id: selectedRow.saleCode as string, mode: "look", },
            true
        );
    }
    const cancellation = async () => {
        if (selectedRowKeys.length !== 1) {
            // globalPrompt("message", { text: "请选择单条数据进行作废", type: "warning" });
            globalPrompt("message", { text: Locale["Please select a single piece of data for cancellation."], type: "warning" });
            return;
        }
        let val: string = ""
        globalPrompt("modal", {
            // title: "销售单作废",
            title: Locale["Cancel the Sales doc."],
            type: "error",
            text: "",
            // <><span>请输入作废原因</span>
            //     <Input onChange={(e) => { val = e.target.value }} /></>,
            // okText: "确定",
            okText: Locale["Yes No"],
            onOk: () => {
                let obj = {
                    id: selectedRow.id,
                    saleCode: selectedRow.saleCode
                    // val
                }
                invalidateData(obj)
            },
            // cancelText: "取消",
            cancelText: Locale["cancel"],
            onCancel: () => {
            }
        })
    }
    const onSettle = async () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: Locale["Please select a single piece of data for editing."], type: "warning" })
            return;
        }
        let { saleCode, id } = selectedRow
        globalPrompt("modal", {
            // title: "销售单结算",
            title: Locale["Settle the Sales doc."],
            type: "success",
            text: "",
            // <><span>请输入作废原因</span>
            //     <Input onChange={(e) => { val = e.target.value }} /></>,
            // okText: "确定",
            okText: Locale["Yes No"],
            onOk: async () => {
                let retData = await Settle({ saleCode, id })
                // retData ? message.success("结算成功") && loadData() : message.error("结算失败")
                retData ? message.success(Locale["Successfully settled"]) && loadData() : message.error(Locale["Unsuccessfully settled"])
            },
            // cancelText: "取消",
            cancelText: Locale["cancel"],
            onCancel: () => {
            }
        })
    }
    const onWhConfirm = async () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: Locale["Please select a single piece of data for editing."], type: "warning" });
            return;
        }
        let { saleCode, id } = selectedRow
        globalPrompt("modal", {
            // title: "销售单出库",
            title: Locale["Stock out the Sales doc."],
            type: "success",
            text: "",
            // <><span>请输入作废原因</span>
            //     <Input onChange={(e) => { val = e.target.value }} /></>,
            // okText: "确定",
            okText: Locale["Yes No"],
            onOk: async () => {
                let retData = await WhConfirm({ saleCode, id })
                // retData ? message.success("出库成功") && loadData() : message.error("出库失败")
                retData ? message.success(Locale["Successfully stocked out"]) && loadData() : message.error(Locale["Unsuccessfully stocked out"])
            },
            // cancelText: "取消",
            cancelText: Locale["cancel"],
            onCancel: () => {
            }
        })
        // let retData = await WhConfirm({ saleCode, id })
        // retData ? message.success("出库成功") && loadData() : message.error("出库失败")
    }
    const onPrint = () => {
        if (selectedRowKeys.length !== 1) {
            // globalPrompt("message", { text: "请选择单条数据进行操作", type: "warning" });
            globalPrompt("message", { text: Locale["Please select a single piece of data for editing."], type: "warning" });

            return;
        }
        setPrint(true)
    }
    const onExport = () => {
        listExport().then()
    }
    const MenuExport = () => {
        return (
            <Menu>
                <Menu.Item key="0">
                    <span onClick={onExport}>{Locale["List export"]}</span>
                </Menu.Item>
                <Menu.Item key="1">
                    <span onClick={detailsExport}>{Locale["Details export"]}</span>
                </Menu.Item>
            </Menu>
        )
    }
    const action = <>
        <AuthButton
            // resCode="MaterialSalesAdd"
            resCode={ResourcesAuthBtn[mianCode]["MaterialSalesAdd"]}
            onClick={() => addNav("2-3-1", { id: "", mode: "add" })}
            // name="新增"
            name={Locale["Add"]}
        />
        <AuthButton
            // resCode="MaterialSalesEdit"
            resCode={ResourcesAuthBtn[mianCode]["MaterialSalesEdit"]}
            onClick={onEdit}
            // name="编辑"
            name={Locale["Edit"]}
        />
        <AuthButton
            // resCode="MaterialSalesView"
            resCode={ResourcesAuthBtn[mianCode]["MaterialSalesView"]}
            onClick={onLook}
            // name="查看"
            name={Locale["View"]}
        />
        <AuthButton
            // resCode="MaterialSalesPayment"
            resCode={ResourcesAuthBtn[mianCode]["MaterialSalesPayment"]}
            onClick={onSettle}
            // name="结算"
            name={Locale["Settle"]}
        />
        <AuthButton
            // resCode="MaterialSalesStockout"
            resCode={ResourcesAuthBtn[mianCode]["MaterialSalesStockout"]}
            onClick={onWhConfirm}
            // name="出库"
            name={Locale["Stock out"]}
        />
        <AuthButton
            // resCode="MaterialSalesPrint"
            resCode={ResourcesAuthBtn[mianCode]["MaterialSalesPrint"]}
            onClick={onPrint}
            // name="打印"
            name={Locale["Print"]}
        />
        <AuthButton
            // resCode="MaterialSalesCancel"
            resCode={ResourcesAuthBtn[mianCode]["MaterialSalesCancel"]}
            onClick={cancellation}
            // name="作废"
            name={Locale["Cancel"]}
        />
        <Dropdown overlay={MenuExport}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
            >{Locale["export"]}<DownOutlined /></Button>
        </Dropdown>
        {/* <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => addNav("2-3-1", { id: "", mode: "add" })}
        >新增</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onEdit}
        >编辑</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onLook}
        >查看</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onSettle}
        >结算</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onWhConfirm}
        >出库</Button>        
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onPrint}
        >打印</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={cancellation}
        >作废</Button>         */}
    </>;
    const desc: IDescription[] = [
        {
            // label: "销售数量",
            label: Locale["Sales Qty"],
            value:selectedRowKeys.length === 0 ? descTotal.totalNum:(rowsDescTotal.totalNum),
            color: DescriptionColorEnum.red
        },
        {
            // label: "销售金额",
            label: Locale["Sales Amount"],
            value:selectedRowKeys.length === 0 ? descTotal.totalAmount:formatNum(rowsDescTotal.totalAmount),
            color: DescriptionColorEnum.red
        },
        {
            // label: "优惠金额",
            label: Locale["Discount Amount"],
            value:selectedRowKeys.length === 0 ? descTotal.discountTotalAmount:formatNum(rowsDescTotal.discountTotalAmount),
            color: DescriptionColorEnum.red
        },
        {
            // label: "应收金额",
            label: Locale["Receivable Amount"],
            value:selectedRowKeys.length === 0 ? descTotal.receivedAmount:formatNum(rowsDescTotal.receivedAmount),
            color: DescriptionColorEnum.red
        },
        {
            // label: "已收金额",
            label: Locale["Received Amount"],
            value:selectedRowKeys.length === 0 ? descTotal.amountReceived:formatNum(rowsDescTotal.amountReceived),
            color: DescriptionColorEnum.red
        },
    ]
    return (
        <YhBox title={<></>} descriptions={desc} action={action} >

            <DataTable />
        </YhBox>
    )
}